import { useCallback, useEffect, useState } from "react";
import { http } from "../lib/api";
import { UserMinus, PencilSimple } from "@phosphor-icons/react";

/* Admin/PM banner: staff who have not marked a half whose window already closed today. */
export function MissedCheckinsCard({ onManualMark }) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data: d } = await http.get("/attendance/missed");
      setData(d);
    } catch (err) {
      console.error("attendance/missed failed", err);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, [load]);

  const blocks = (data?.halves || []).filter((b) => b.count > 0);
  if (blocks.length === 0) return null;

  return (
    <div className="border-2 border-red-600 bg-red-50 mb-6" data-testid="missed-checkins-card">
      {blocks.map((b) => (
        <div key={b.half} className="p-4 border-b border-red-200 last:border-b-0" data-testid={`missed-${b.half}`}>
          <div className="label-overline text-red-700 flex items-center gap-1.5">
            <UserMinus size={12} weight="bold" />
            {b.count} staff missed {b.half === "first" ? "morning" : "evening"} check-in · {data.date} · window {b.window}
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {b.staff.map((u) => (
              <span key={u.id} className="inline-flex items-center gap-1 bg-white border border-red-300 text-red-900 text-xs px-2 py-1"
                    data-testid={`missed-staff-${u.id}`}>
                {u.name} <span className="text-red-400">· {u.role}</span>
                {onManualMark && (
                  <button type="button" onClick={() => onManualMark(u.id)} title="Manual mark"
                          data-testid={`missed-manual-${u.id}`}
                          className="ml-1 text-red-400 hover:text-orange-600">
                    <PencilSimple size={11} weight="bold" />
                  </button>
                )}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
